import { KanbanFieldFormatBaseValueConverter } from 'General/Resources/ValueConverters/KanbanFieldFormatBase';

export class KanbanFieldFormatValueConverter extends KanbanFieldFormatBaseValueConverter{

}